/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Container } from "react-awesome-styled-grid";
import { useLocation, Redirect } from "react-router-dom";
import styled from "styled-components";
import { Heading } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { BASE_NAME } from "~/components/config";
import { show } from "~/components/Styled/animation";

const StyledWrap = styled.div`
  opacity: 0;
  transition: ease-in-out;
  animation: ${show} 0.2s 0.5s forwards;
`;
export function PageNotFound() {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  if (parts[1] === BASE_NAME) {
    const newPath = pathname.replace(`/${BASE_NAME}`, "");

    return <Redirect to={newPath} />;
  }

  return (
    <Container>
      <FlexContainer>
        <StyledWrap>
          <div style={{ transform: "rotate(-15deg)" }}>
            <Heading level={1} mb={0}>
              Ooooops
            </Heading>
            <Heading level={4}>There is no such page :( </Heading>
          </div>
        </StyledWrap>
      </FlexContainer>
    </Container>
  );
}
